import { User } from 'Browser/User';
import { VenueRole } from 'Common/permissions/VenueRole';
import { SiteBasics } from 'Common/SiteBasics';
import { useBuild, useSite, useUser } from 'Shared/SiteProvider';
import { Match, Show, Switch } from 'solid-js';
import { isServer } from 'solid-js/web';


export function Page(P:{requiresLogin:boolean})
{
	log.debug('Page() requiresLogin:',P.requiresLogin,'isServer:',isServer);

	const site = useSite();
	const user = useUser();

	if (!isServer)
		handleLoginParam(P.requiresLogin);

//TODO provide decent Missing permissions and Page not found errors... 
//     Maybe share an ErrorPage?
//TODO omit error call stack in production (better done server-side)


//XXX if using ErrorBoundary probably should send errors to server
//XXX perhaps also send browser-side 'page not founds' to server

//XXX ErrorBoundary sometimes hides errors... Also could put in Root.tsx
//		<ErrorBoundary fallback={err => <pre>{JSON.stringify(err)}</pre>}>

	const havePermission = site.type!='venue' || haveVenueRole(user,site);

	return (
		<Switch>
			<Match when={!P.requiresLogin}>
				{P.children}
			</Match>
			<Match when={!user.isUnknown()}>
				<Show when={havePermission} fallback='You lack the permissions for this site'>
					{P.children}
				</Show>
			</Match>
		</Switch>
	);

//		</ErrorBoundary>
}

function handleLoginParam(requiresLogin:boolean)
{
//XXX Cf a dedicated UserProvider? Might make the login stuff slightly clearer
	const build = useBuild();
	const user = useUser();
	const url = new URL(location.href);
	const params = url.searchParams;

	log.debug('handleLoginParam() url:',url);
	log.debug('handleLoginParam() params:',params);

	/* 
		Remove the _login and _vite parameters when present. 
		_isVite will only be present when _login is present. 
	*/
	const hasLoginParam = params.has('_login');
	const hasViteParam = params.has('_isVite');
	if (hasLoginParam) {
		params.delete('_login');
		params.delete('_isVite');
		history.replaceState(null,'',url.pathname+url.hash);
	}

	log.debug('handleLoginParam() hasLoginParam:',hasLoginParam);
	log.debug('handleLoginParam() hasViteParam:',hasViteParam);

	/* If we need a session, but dont have a cookie for this domain (yet)... */
	if (requiresLogin && user.isUnknown()) {
		log.debug('handleLoginParam() requiresLogin && isUnknown');

		if (hasLoginParam)
			if (hasViteParam)
				/* Vite proxies the ?_login request version to set the cookie so now load the unproxied page... */
				location.reload();
			else
				/* This is just a safeguard against unanticipated events: */
				throw new Error('Interrupted a login redirection loop');

		log.debug('handleLoginParam() calling location.replace() location.href:',location.href);

		location.replace(build.loginUrl+'?return='+encodeURIComponent(location.href));
	}

	log.debug('handleLoginParam() END');
}

//TODO possibly move to Roles or VenueRoles
function haveVenueRole(user:User,site:SiteBasics)
{
	for (const role of user.roles) 
		if (role instanceof VenueRole && role.config.siteId.toString()==site.id)  //XXX the toString() cast here is hacky
			return true;

	return false;
}

